import SelectPro from './src'

SelectPro.install = Vue => {
  Vue.component(SelectPro.name, SelectPro)
}

export default SelectPro
